/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaCellNote from './AqaCellNote';

/**
 * The AqaValue model module.
 * @module model/AqaValue
 * @version v0
 */
export default class AqaValue {
  /**
   * Constructs a new <code>AqaValue</code>.
   * @alias module:model/AqaValue
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaValue</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaValue} obj Optional instance to populate.
   * @return {module:model/AqaValue} The populated <code>AqaValue</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaValue();
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('orignalValue'))
        obj.orignalValue = ApiClient.convertToType(data['orignalValue'], 'String');
      if (data.hasOwnProperty('coercedValue'))
        obj.coercedValue = ApiClient.convertToType(data['coercedValue'], 'String');
      if (data.hasOwnProperty('note'))
        obj.note = AqaCellNote.constructFromObject(data['note']);
    }
    return obj;
  }
}

/**
 * @member {String} type
 */
AqaValue.prototype.type = undefined;

/**
 * @member {String} orignalValue
 */
AqaValue.prototype.orignalValue = undefined;

/**
 * @member {String} coercedValue
 */
AqaValue.prototype.coercedValue = undefined;

/**
 * @member {module:model/AqaCellNote} note
 */
AqaValue.prototype.note = undefined;

